import { createSlice } from "@reduxjs/toolkit"

const initState = {
    count:0
}

let counterSlice = createSlice({
    name:'counter',
    initialState:initState,
    reducers:{
        increment : function(state,action){
            state.count = state.count +1
        },
        decrement:function(state,action){
            if(state.count > 0){
                state.count = state.count -1
            }
           
        },
        incrementBy : function(state,action){
            state.count = state.count + action.payload
        },
        decrementBy:function(state,action){
            if(state.count >= 5){
                state.count = state.count - action.payload
            }
           
        },
    }
})

export const {increment,decrement,incrementBy,decrementBy} = counterSlice.actions;

export default counterSlice.reducer;